<script>
import DateTimePicker from '@/components/directives/DateTimePicker.vue';
import NumberInput from '@/components/directives/NumberInput.vue';

export default {
  name: 'AdjustmentFormModal',
  components: { DateTimePicker, NumberInput },
  props: {
    visible: Boolean,
    isEditMode: Boolean,
    isSubmitting: Boolean,
    initialData: Object,
  },
  data() {
    return {
      form: {
        robaId: null,
        robaType: 1,
        robaTime: new Date(),
        robaValue: null,
        robaNote: '',
      },
    };
  },
  computed: {
    title() {
      return this.isEditMode ? 'Edit Adjustment' : 'Add New Adjustment';
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.isEditMode && this.initialData) {
          this.form = { ...this.initialData };
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        robaId: null,
        robaType: 1,
        robaTime: new Date(),
        robaValue: null,
        robaNote: '',
      };
    },
    handleSubmit() {
      this.$emit('submit', this.form);
    },
    closeModal() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<template>
  <b-modal :visible="visible" :title="title" @hidden="closeModal" hide-footer>
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Type">
        <b-form-select v-model="form.robaType" :options="[{value: 1, text: 'Reset Value'}, {value: 2, text: 'Adjust Value'}]" required />
        <b-form-text v-if="form.robaType === 1">Reset Value resets the current value to the specified value.</b-form-text>
      </b-form-group>
      <b-form-group label="Time">
        <date-time-picker v-model="form.robaTime" />
      </b-form-group>
      <b-form-group label="Value">
        <NumberInput v-model="form.robaValue" class="form-control" required />
        <b-form-text>Use negative number (-) for subtraction.</b-form-text>
      </b-form-group>
      <b-form-group label="Note">
        <b-form-textarea v-model="form.robaNote" rows="3" maxlength="255" />
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="secondary" @click="closeModal" class="mr-2">Cancel</b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">
          {{ isSubmitting ? 'Saving...' : 'Save' }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
